/**
 * Landing 首页 data
 * 结构对应现网 LoEvent 主页：Hero → Statement → 3 个 FeatureSplit (Pro/Connect/Business)
 */
import type { PageData } from '@/content/types';
import { organizationJsonLd, websiteJsonLd } from '../../src/content/shared';

export const data: PageData = {
  seo: {
    title: 'LoEvent - End to End Event Organizing AI AGENT Platform',
    description:
      'First Market Event AI Agent Platform. One intelligent platform for organizers, attendees, and businesses—from event planning to networking to enterprise solution.',
    ogImage: '/images/ogimage.jpg',
    jsonLd: [organizationJsonLd(), websiteJsonLd()],
  },
  sections: [
    {
      type: 'hero',
      data: {
        pill: { label: '1.0 Beta Online', dot: true },
        headline: 'First AI Agent for\nin-person events',
        subheadline:
          'One intelligent platform for organizers, attendees, and businesses—from event planning to networking to enterprise solution.',
        cta: { label: 'Start Planning Free', href: 'https://app.loevent.com/pro', variant: 'primary' },
        screenshot: { src: '/images/hero.webp', alt: 'LoEvent platform overview showing event planning, networking, and enterprise solutions for AI tech industry', width: 1440, height: 810 },
      },
    },
    {
      type: 'feature-split',
      data: {
        eyebrow: { label: 'Less prompting, More time on your event.' },
        title: 'LoEvent Pro',
        lines: [
          'One-click automate workflow execution.',
          'Eliminates 40+ hours of manual work per event.',
        ],
        body: 'From event planning to prep task management, branded poster creation and social media content. Built specifically for solo organizers, small teams, and startup communities in AI and Web3.',
        cta: { label: 'Get Started', href: '/pro', variant: 'ghost' },
        image: { src: '/images/pro-hero.webp', alt: 'LoEvent Pro workspace showing AI-generated event poster, strategy planner, and task board for AI tech meetup organization', width: 1440, height: 812 },
        imagePosition: 'right',
        tint: 'blue',
      },
    },
    {
      type: 'feature-split',
      data: {
        eyebrow: { label: 'Find Events and help you convert' },
        title: 'LoEvent Connect',
        lines: [
          'Stop missing critical sessions.',
          'Stop collecting business cards that go nowhere.',
          'Turn attendance into convertible opportunities.',
        ],
        body: 'Your intelligent event companion—filtering through hundreds of sessions to surface what matters, recommending optimal agendas based on your interests, and enabling real-time networking matchmaking.',
        cta: { label: 'Get Started', href: '/connect', variant: 'ghost' },
        image: { src: '/images/connect.webp', alt: 'LoEvent Connect interface showing intelligent session filtering and real-time networking matchmaking for AI conference attendees', width: 1024, height: 958 },
        imagePosition: 'left',
        tint: 'amber',
      },
    },
    {
      type: 'feature-split',
      data: {
        eyebrow: { label: 'Event ROI driven AI Agent platform' },
        title: 'LoEvent Business',
        lines: [
          'Stop juggling scattered tools.',
          'Stop recreating workflows from scratch.',
          'Start running events as a scalable system.',
        ],
        body: 'Built for teams that turn events into predictable revenue channels with complete event operations—strategic planning, attendee management, brand consistency, replicable templates, and post-event ROI analytics.',
        cta: { label: 'Get Started', href: '/business', variant: 'ghost' },
        image: { src: '/images/business.webp', alt: 'LoEvent Business dashboard showing strategic planning, attendee management, and post-event ROI analytics for enterprise event teams', width: 1440, height: 787 },
        imagePosition: 'right',
        tint: 'violet',
      },
    },
    {
      type: 'statement',
      data: {
        title: 'One Canvas. Strategy to Assets.',
        highlight: 'Click to plan. Click to Growth.',
      },
    },
  ],
};
